<template>
  <v-app>
    <v-content>
      <v-container>
        <v-layout>
          <v-flex xs12 sm8 offset-sm2>
            <v-card>
              <v-toolbar
                dense
                flat
                card
                dark
                color="primary"
              >
                <img 
                  src="@/assets/nihr-logo.svg" 
                  alt="National Institute for Health and Care Research"
                  width="160">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  
                </v-toolbar-items>
              </v-toolbar>
              <v-layout justify-center align-center fill-height>
                <v-card-text>
                  <p class="headline text-xs-center">
                    Thank you for registering to use
                    Mentor{{coachText}} Directory
                  </p>
                  <p class="subheading text-xs-center">
                    A verification email has been sent to your {{userEmail}} email address.
                  </p>
                </v-card-text>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
  
export default {
  name: 'notauth',
  data () {
    return {
      dialog: false,
      valid: true
    }
  },
  computed: {
    userEmail: function () {
      // get the current user's email from the store
      return this.$store.getters.getUserEmail
    },
    userName: function () {
      // get the current user's display name from the store
      return this.$store.getters.getUserName
    },
    includeCoach: function () {
      return this.$store.getters.getIncludeCoach
    },
    coachText: function () {
      if (this.includeCoach) {
        return '/Coach'
      } else {
        return ''
      }
    }
  },
  created() {
    //this.$store.dispatch("updateAppTitle")
    // make sure we're at the top of the form (especially useful if we're returning from one of the forms)
    window.scrollTo(0, 0);
    //log the un-authorised user out of the app so using the back button will return them to the login screen
    this.logOut()
  },
  methods: {
    logOut: function() {
      firebase.auth().signOut()
        .then(() => {
          console.log("Un-Authorised User Logged Out!")
        })
    }
  }
}
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .card-form-list {
      margin-top: 10px;
  }
    
  .card-study-site {
      margin-top: 10px;
  }

  p {
    white-space: pre-line;
  }
</style>
